export function isArray(value: any): value is Array<unknown> {
  return Array.isArray(value);
}

export function isBoolean(value: any): value is Boolean {
  if (typeof value === 'boolean') {
    return true;
  }

  if (typeof value === 'string') {
    const lowercaseValue = value.toLowerCase();
    return lowercaseValue === 'true' || lowercaseValue === 'false';
  }

  return false;
}
export function isEmptyObject(obj: any): boolean {
  if (obj === null || obj === undefined) {
    return true;
  }
  return typeof obj === 'object' && Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function isEmptyArray(obj: any): boolean {
  if (obj === null || obj === undefined) {
    return true;
  }
  return isArray(obj) && obj?.length === 0;
}

export function isEmpty(value: any): boolean {
  if (isArray(value) && isEmptyArray(value)) {
    return true;
  }
  if (typeof value === 'object' && isEmptyObject(value)) {
    return true;
  }
  return value === undefined || value === null || value === '';
}

export function isNotEmpty(value: any): boolean {
  return !isEmpty(value);
}

export function isUndefined<T>(value: T | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}

export function isDefined<T>(value: T | null | undefined): value is T {
  return !isUndefined(value);
}

export function isFunction(value: any): value is Function {
  return typeof value === 'function';
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function isPromise<T = unknown>(value: any): value is Promise<T> {
  return typeof value?.then === 'function';
}

export function isString(value: any): value is string {
  return typeof value === 'string' || value instanceof String;
}

export function isObject(value: any): value is Object | object {
  return typeof value === 'object' && !!value;
}

/**
 * @description
 * assert value to be a number or not. it uses reg exp pattern to deliver the result
 * for the current value, it can evaluate number with or without numeric chars which
 * are not numbers like decimal point (123.45)
 * @param value a variable value of any type
 * @param options
 *    withDecimal - evaluate value as a decimal, so "." char is acceptable
 *    withFormat - evaluate value as a formatted number, so "," char is acceptable
 * @returns a boolean: true - if numeric evaluation succeeds, false - if not
 */
export function isNumber(value: any, options: { withFormat?: boolean } = { withFormat: true }): value is Number {
  const { withFormat } = options;

  if (isEmpty(value)) {
    return false;
  }

  if (withFormat) {
    return /^(\d+(?:\.\d+)?|\.\d+|\d{1,3}(?:,\d{3})+(?:\.\d+)?)$/.test(value.toString());
  }

  return /^[+-]?([0-9]*[.])?[0-9]+$/.test(value.toString());
}

// export function parseNumber(input: string): number {
//   /** regular expression to match any character that is not a digit or a decimal point */
//   const cleanedString = input.replace(/[^\d.]/g, '');

//   if (!cleanedString || isNaN(parseFloat(cleanedString))) {
//     return 0;
//   }

//   /** convert the cleaned string to a number */
//   const numericValue = parseFloat(cleanedString);
//   return numericValue;
// }
